<template>
  <div class="newDataPage">
    <div class="steps">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>
    <div class="steps-content">
      <template v-if="current == 0">
        <new-customer @setFactory="setFactory" :customerInfo="customerInfo" ref="newCustomer"></new-customer>
      </template>
      <template v-if="current == 1">
        <new-feed-info 
          ref="newFeedInfo"
          @setFeedInfo="setFeedInfo" 
          :selectFactory="selectFactory" 
          :factoryId="factoryId"
          :poultryLineEggFeedInfo="poultryLineEggFeedInfo"
        />
      </template>
      <template v-if="current == 2">
        <new-customer-feedback 
          ref="newCustomerFeedback" 
          @setFeedBack="setFeedBack" 
          :poultryLineFeedback="poultryLineFeedback"
          @setFileList="setFileList"
          :fileListProp="{fileList,videoFileList}"
        />
      </template>
      <template v-if="current ==3">
        <new-finish 
          :returnList="returnList" 
          :saveSuccess="saveSuccess" 
          :recordId="recordId"
          @saveData="'saveData'"
        />
      </template>
    </div>
    <div class="footer">
      <a-button v-if="current > 0 && current < steps.length-1" @click="prev">上一步</a-button>
      <a-button v-if="current == 0" @click="returnList">取 消</a-button>
      <a-button v-if="current < steps.length - 2" type="primary" @click="next" style="margin-left: 10px">下一步</a-button>
      <a-button v-if="current == 2" type="primary" @click="next" style="margin-left: 10px">提 交</a-button>
    </div>
    <calculation-result-modal 
      :visible="visible" 
      @isShow="isShow"
      :calculationResult="calculationResult"
      :calculationAbnormal="calculationAbnormal"
      @calculationAbnormalInit="calculationAbnormalInit"
      @calculationConfirm="calculationConfirm"
    />
  </div>
</template>
<script>
import NewCustomer from './EggNewDataComponents/NewCustomer.vue';
import NewCustomerFeedback from './EggNewDataComponents/NewCustomerFeedback.vue';
import NewFeedInfo from './EggNewDataComponents/NewFeedInfo.vue';
import NewFinish from './EggNewDataComponents/NewFinish.vue';
import CalculationResultModal from './EggNewDataComponents/CalculationResultModal.vue'
import api from '../EmpiricalData/api'
export default {
  components: { NewCustomer, NewFeedInfo, NewCustomerFeedback, NewFinish, CalculationResultModal},
  data() {
    return {
      current: 0,
      steps: [
        {title: '填写客户信息'},
        {title: '填写饲养信息'},
        {title: '填写客户反馈'},
        {title: '完成'},
      ],
      selectFactory:'',
      factoryId:'',
      customerInfo:{},
      poultryLineFeedback:{},
      uploadFiles:{},
      visible:false,
      poultryLineEggFeedInfo:{},
      calculationResult:{},
      calculationAbnormal:[],
      settlementId:'',
      saveSuccess:false,
      recordId:'',
      fileList:[],
      videoFileList:[],
    };
  },
  mounted(){
    if(this.$route.query.copyId) this.copyValues()
  },
  methods: {
    async copyValues(){
      let {copyId} = this.$route.query
      let params = {
        recordId: copyId,
        lineType: 'POULTRY_LINE_EGG'
      }
      let res = await api.pigDetail(params)
      if(!res.success) this.$message.error(res.msg) 
      this.poultryLineEggFeedInfo = res?.data?.poultryLineEggFeedInfo || {}
      this.customerInfo = res?.data?.poultryLineCustomerInfo || {}
      this.customerInfo.region = this.customerInfo.province&&this.customerInfo.city&&this.customerInfo.area ?
       [this.customerInfo.province,this.customerInfo.city,this.customerInfo.area] : undefined
       if(!(this.customerInfo.createUser == window.localStorage.getItem('staffId')) && this.poultryLineEggFeedInfo.feedBrand == '新希望'){
        this.poultryLineEggFeedInfo.productName = ''
        this.poultryLineEggFeedInfo.nhfFormulaId = ''
        this.poultryLineEggFeedInfo.modelCode = ''
        this.poultryLineEggFeedInfo.modelName = ''
      }
      this.calculationResult = res?.data?.calculationResult || {}
      this.poultryLineFeedback = res?.data?.poultryLineFeedback || {}
      this.uploadFiles = res?.data?.uploadFiles || {}
      this.loadFiles()
    },
    next() {
      if(this.current == 0){
        this.$refs.newCustomer.form.validateFields((err, values) => {
          if (!err) {
            this.customerInfo = values
            this.current++;
          }
        })
      }
      else if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          if (!err) {
            this.poultryLineEggFeedInfo = values
            this.$refs.newFeedInfo.sendData()
            this.getCalculationResult()
          }
        })
      }
      else if(this.current == 2){
        //保存数据
        this.$refs.newCustomerFeedback.form.validateFields((err) => {
          if (!err) {
            this.$refs.newCustomerFeedback.sendData()
            this.saveData()
          }
        })
        // this.current++;
      }
    },
    prev() {
      if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          this.poultryLineEggFeedInfo = values,
          this.$refs.newFeedInfo.sendData()
        })
      }
      else if(this.current == 2){
        this.$refs.newCustomerFeedback.sendData()
      }
      this.current--;
    },
    isShow(val){
      this.visible = val
    },
    setFactory(value) {
      this.factoryId = value.factoryId
      this.selectFactory = value.selectFactory
      this.settlementId = value.settlementId
      this.settlementName = value.settlementName
    },
    setFeedInfo(value) {
      this.poultryLineEggFeedInfo = {
        ...this.poultryLineEggFeedInfo,
        nhfFormulaId:value.nhfFormulaId,
        modelName:value.modelName,
        modelCode:value.modelCode,
      }
    },
    setFeedBack(value) {
      this.poultryLineFeedback = value
    },
    setFileList(value){
      this.fileList = value.fileList
      this.videoFileList =value.videoFileList
    },
    returnList(){
      this.$router.push({
        path: '/empirical-data/poultry',
        query:{
          name: '禽线路',
        }
      })
    },
    async getCalculationResult(){
      const res = await this.$http.post("/sat-collect/poultryLine/egg/calculate", { 
        poultryLineEggFeedInfo:this.poultryLineEggFeedInfo,
      })
      let { msg,success,data } = res;
      if(data) this.calculationResult = data 
      if(!success) this.calculationAbnormal = msg.split(",")
      this.visible = true
    },
    calculationConfirm(){
      this.current++;
    },
    calculationAbnormalInit(){
      this.calculationAbnormal = []
    },
    async saveData(){
      let params = {
        lineType:'POULTRY_LINE_EGG',
        poultryLineCustomerInfo:{
          ...this.customerInfo,
          type:2,
          province:this.customerInfo.region ? this.customerInfo.region[0] : undefined,
          city:this.customerInfo.region ? this.customerInfo.region[1] : undefined,
          area:this.customerInfo.region ? this.customerInfo.region[2] : undefined,
          factoryId:this.factoryId,
          settlementId:this.settlementId,
          settlementName:this.settlementName,
        },
        poultryLineEggFeedInfo:this.poultryLineEggFeedInfo,
        poultryLineMeatFeedInfo:{},
        poultryLineMeatRaiseInfos:[],
        poultryLineEggProductResult:this.calculationResult,
        poultryLineMeatProductResult:{},
        poultryLineFeedback:this.poultryLineFeedback,
        uploadFiles:this.poultryLineFeedback.uploadFiles
      }
      const res = await this.$http.post("/sat-collect/poultryLine/save", params)
      this.saveSuccess = res.success
      if(res.success) this.recordId = res.data.poultryLineCustomerInfo.id
      this.current++
    },
    loadFiles() {
      this.fileList = []
      this.videoFileList = []
      this.uploadFiles?.forEach(item => {
        const fileName = item.fileName
        const arr = fileName.split("/")
        const name = arr[arr.length-1]
        this.$http.get('/sat-collect/upload/getFileUrlList',{ params:{fileName} }).then(res =>{
          if(item.mediaType == 'PIC'){
            this.fileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
          if(item.mediaType == 'VIDEO'){
            this.videoFileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
        })
      })
    }
  },
};
</script>

<style lang='scss'>
.newDataPage{
  background-color: #fff;
  margin-top: 20px;
  min-height: 90%;
  .ant-form-item-label{
    line-height: 20px;
  }
  .ant-form-explain{
    margin-top: -2px;
  }
}
.steps{
  padding: 30px;
}
.footer{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 8px;
  background: #fff;
  text-align: center;
  z-index: 1;
  .ant-btn{
    font-size: small !important
  }
}
</style>